import {
  catalogueSummary,
  useImportCsvMutation,
} from '@/features/imports/api/use-import-csv-mutation';
import { queryKeys } from '@/lib/query-keys';
import type {
  ImportOffersCsvInput,
  ImportOffersCsvResponse,
} from '@borradh-workspace/api-client/types';
import { importOffersCsvResponseSchema } from '@borradh-workspace/contracts';

export const useImportOffersCsv = (options?: {
  onSuccess?: (result: ImportOffersCsvResponse) => void;
}) => {
  const { mutate, mutateAsync, isImporting } = useImportCsvMutation<
    ImportOffersCsvInput,
    ImportOffersCsvResponse
  >({
    path: 'offers/import-csv',
    schema: importOffersCsvResponseSchema,
    event: 'offers_imported_csv',
    track: (r) => ({
      imported: r.imported,
      updated: r.updated,
      skipped: r.skipped,
      rowsInFile: r.rowsInFile,
      servicesLinked: r.servicesLinked,
      locationsLinked: r.locationsLinked,
    }),
    invalidate: () => [queryKeys.offers.all()],
    summarize: catalogueSummary,
    onSuccess: options?.onSuccess,
  });
  return {
    importOffersCsv: mutate,
    importOffersCsvAsync: mutateAsync,
    isImporting,
  };
};
